"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _reactFulcrum = require("@upgrowth/react-fulcrum");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AddOptions = function (_React$Component) {
  (0, _inherits3.default)(AddOptions, _React$Component);

  function AddOptions() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AddOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddOptions.__proto__ || (0, _getPrototypeOf2.default)(AddOptions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AddOptions, [{
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _props = this.props,
          onAdd = _props.onAdd,
          options = _props.options;
      return _react2.default.createElement("div", {
        className: "AddOptions"
      }, (0, _lodash.map)(options, function (option, key) {
        return _react2.default.createElement(_reactFulcrum.Button, {
          variant: "primary",
          onClick: function onClick() {
            return onAdd(option);
          },
          key: key
        }, "+ ", option.label);
      }));
    }
  }]);
  return AddOptions;
}(_react2.default.Component);

exports.default = AddOptions;